import axios from 'axios';

import parseExerciseFilesForUI from '../_commonParsers/parseExerciseFilesForUI';
import type {
  ExercisesSetDto,
  ExercisesSet,
  ExercisesSetDetails,
  ExercisesSetDetailsDto,
  CreateExercisesSetDataDto,
  UpdateExercisesSetData,
  UpdateExercisesSetDataDto,
  AppendExercisesSetData,
  AppendExercisesSetDataDto,
  ExerciseInSetDto,
} from './exercisesSet.types';
import { CreateExercisesSetData } from './exercisesSet.types';

const parseListExercises = (raw: ExercisesSetDto['exercises']): ExerciseInSetDto[] | undefined => {
  if (raw == null) return undefined;

  const items = Array.isArray(raw) ? raw : Object.values(raw);
  const parsed = items.flatMap(item => {
    if (!item || typeof item !== 'object') return [];
    const { index, subject, uuid } = item as Record<string, unknown>;
    if (typeof index !== 'number' || typeof subject !== 'number') return [];
    return [
      {
        index,
        subject,
        uuid: typeof uuid === 'string' ? uuid : '',
      },
    ];
  });

  return parsed;
};

export const parseExercisesSetForFE = (raw: ExercisesSetDto[]): ExercisesSet[] =>
  raw.map(({ id, name, exercises }) => ({
    id,
    name,
    exercises: parseListExercises(exercises),
  }));

export const parseExercisesSetDetailsForFE = (raw: ExercisesSetDetailsDto): ExercisesSetDetails => ({
  exercises: (raw.exercises ?? []).map(({ uuid, subject, index, global_id, files }) => ({
    globalId: global_id,
    files: parseExerciseFilesForUI(files),
    uuid,
    subject,
    index,
  })),
  id: raw.id,
  name: raw.name,
});

export const parseCreateExercisesSetForBE = (dataFormUI: CreateExercisesSetData): CreateExercisesSetDataDto => dataFormUI;

export const parseUpdateExercisesSetForBE = (dataFormUI: UpdateExercisesSetData): UpdateExercisesSetDataDto => dataFormUI;

export const parseAppendExercisesSetForBE = (dataFormUI: AppendExercisesSetData): AppendExercisesSetDataDto => ({
  index: dataFormUI.exerciseIndex,
  subject_id: dataFormUI.subject,
});

const firstString = (value: unknown): string | null => {
  if (typeof value === 'string' && value) {
    return value;
  }
  if (Array.isArray(value) && typeof value[0] === 'string' && value[0]) {
    return value[0];
  }
  return null;
};

export const parseAppendErrorMessage = (error: unknown): string => {
  if (!axios.isAxiosError(error)) {
    return 'Wystąpił nieznany błąd';
  }

  const data = error.response?.data;
  if (typeof data === 'string' && data) {
    return data;
  }
  if (!data || typeof data !== 'object') {
    return 'Wystąpił nieznany błąd';
  }

  const payload = data as Record<string, unknown>;
  return firstString(payload._error) ?? firstString(payload.detail) ?? firstString(payload.message) ?? 'Wystąpił nieznany błąd';
};
